import React from 'react';
import classNames from 'classnames';

import { EmptyState } from 'components';

import LoadingGroupsSkeleton from '../LoadingGroupsSkeleton';
import VariationsGroup from '../VariationsGroup';

import styles from './VariationsGroups.module.scss';

const VariationsGroups = ({ groups = [], isLoading, isSilentLoading, emptyStateType, refreshCallback }) => {
  if (isLoading) return <LoadingGroupsSkeleton />;
  if (groups.length < 1) return <EmptyState type={emptyStateType} />;

  return (
    <div className={classNames(styles.container, { [styles.isSilentLoading]: isSilentLoading })}>
      {groups.map((group) => (
        <VariationsGroup
          key={group.id}
          refreshCallback={refreshCallback}
          {...group}
        />
      ))}
    </div>
  );
};

export default VariationsGroups;
